var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('klk-breadcrumb',{staticClass:"subvertical-breadcrumb"},_vm._l((_vm.breadcrumbList),function(item){return _c('klk-breadcrumb-item',{key:item.id,attrs:{"href":item.deeplink}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }